import { styled } from "@mui/material/styles";

// Images
import LoginImage from "~/assets/images/LoginImage.png";

const styledName = "Login";
export const StyledLoginBackground = styled("div", { name: styledName })({
  "&": {
    position: "relative",
    backgroundImage: `url(${LoginImage})`,
    width: "100vw",
    height: "100vh",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
});

export const StyledFormPosition = styled("div", { name: styledName })({
  "&": {
    position: "absolute",
    height: "fit-content",
    width: "fit-content",
    top: "50%",
    left: "25%",
    transform: `translate(-25%,-50%)`,
  },
});
